module.exports = __webpack_public_path__ + "static/img/dlogo.c0dad4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12